export function mergeTags(listaTags, tags) {
    if (!tags) return;
    // Cria um objeto para mapear os _id de tags com checked no array tags
    let checkedMap = new Map(tags.map(tag => [tag._id, true]));

    // Cria um novo array baseado em listaTags
    let newArray = listaTags.map(tag => {
        return {
            ...tag,
            checked: checkedMap.has(tag._id) ? true : false
        };
    });

    return newArray;
}


export const groupMessagesByDate = (messages) => {
    return messages.reduce((acc, message) => {
      const date = new Date(message.t * 1000).toLocaleDateString();
      if (!acc[date]) {
        acc[date] = [];
      }
      acc[date].push(message);
      return acc;
    }, {});
  };


  export const validaVCard = message => {
    let array = message.body.split("\n");
    let numero = "";
    let contact = "";
    for (let index = 0; index < array.length; index++) {
      const v = array[index];
      let values = v.split(":");
      for (let ind = 0; ind < values.length; ind++) {
        if (values[ind].indexOf("+") !== -1) {
          numero = values[ind]
        }
        if (values[ind].indexOf("FN") !== -1) {
          contact = values[ind + 1];
        }
      }
    }
  }